if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) {
          return;
        }
        this.variantIdInput.disabled = false;
        this.form.querySelectorAll('[data-assembly-option]').forEach((option) => { option.disabled = false; });
        this.form.addEventListener('formdata', (event) => this.prepareAssemblyFormData(event.formData));
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        }
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const floorVariant = this.form.querySelector('[name="id"]')?.value;
        const floorMinimum = window.BlackBearFlooring?.minimum(floorVariant) || 1;
        const floorInput = this.closest('product-info')?.querySelector('.quantity__input') || document.querySelector(`input[name="quantity"][form="${this.form.id}"]`) || this.form.querySelector('[name="quantity"]');
        if (floorMinimum === 8 && floorInput && (!Number.isInteger(Number(floorInput.value)) || Number(floorInput.value) < 8)) {
          this.handleErrorMessage(window.BlackBearFlooring.message);
          floorInput.focus();
          return;
        }
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const quantityInput = this.closest('product-info')?.querySelector('.quantity__input');
        if (quantityInput?.value) {
          if (formData.has('items[0][id]')) {
            formData.set('items[0][quantity]', quantityInput.value);
            formData.set('items[1][quantity]', quantityInput.value);
          } else {
            formData.set('quantity', quantityInput.value);
          }
        }
        
        this.prepareAssemblyFormData(formData);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.items?.length) response.id = response.items[0].id;
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            this.error = true;
            this.handleErrorMessage(this.form.querySelector('[data-assembly-error]')?.dataset.assemblyError || e.message);
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      prepareAssemblyFormData(formData) {
        if (!formData.has('quantity') && window.BlackBearFlooring?.minimum(formData.get('id')) === 8) formData.set('quantity', '8');
        if (formData.has('items[1][id]')) return;
        const quantityInput = this.closest('product-info')?.querySelector('.quantity__input');
        if (quantityInput?.value) formData.set('quantity', quantityInput.value);
        const assemblyOption = this.form.querySelector('[data-assembly-option]:checked');
        if (assemblyOption) {
          const group = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
          const assembly = this.form.querySelector('[data-assembly-product]');
          const quantity = formData.get('quantity') || '1';
          const entries = Array.from(formData.entries());
          entries.forEach(([key, value]) => {
            if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
              formData.delete(key);
              const itemKey = key.startsWith('properties[')
                ? `items[0][${key.replace('[', '][')}`
                : `items[0][${key}]`;
              formData.append(itemKey, value);
            } else if (key.startsWith('bb_assembly_')) {
              formData.delete(key);
            }
          });
          formData.append('items[0][properties][_Assembly group]', group);
          formData.append('items[0][properties][Pre-assembly]', 'Selected — service charged separately');
          formData.append('items[1][id]', assemblyOption.value);
          formData.append('items[1][quantity]', quantity);
          formData.append('items[1][properties][_Assembly group]', group);
          formData.append('items[1][properties][Equipment]', assembly.dataset.assemblyProduct);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) {
          return;
        }
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      
      get variantIdInput() {
        // return this.form.querySelector('[name=id]');
        return this.form ? this.form.querySelector('[name=id]') : null;
      }
    }
  );
}
